import React from "react";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle, Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4">
      <Card className="w-full max-w-lg shadow-lg border border-slate-200 bg-white">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-rose-100 rounded-full animate-pulse" />
              <AlertCircle className="relative h-16 w-16 text-rose-500" />
            </div>
          </div>

          <h1 className="text-4xl font-heading font-bold text-[#0f2b48] mb-2">404</h1>

          <h2 className="text-xl font-semibold text-slate-800 mb-4">
            Page Not Found
          </h2>

          <p className="text-slate-600 mb-8 leading-relaxed text-sm">
            Sorry, the page you are looking for does not exist or may have been relocated.
          </p>

          <div className="flex justify-center">
            <Link
              href="/"
              className="inline-flex items-center gap-2 bg-[#0284c7] hover:bg-[#0369a1] text-white px-6 py-2.5 rounded-lg transition-all shadow-md font-semibold text-sm"
            >
              <Home className="w-4 h-4" />
              Return to Homepage
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
